import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Typography,
  createStyles,
  Button,
} from '@material-ui/core';
import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import CancelIcon from '@material-ui/icons/Cancel';
import theme from '../../../themes/theme';

type Props = {
  open: boolean;
  onClose: () => void;
  updateProfile: () => void;
  updateCard: () => void;
  expiryDateAndYear: string;
};
const useStyles = makeStyles(() =>
  createStyles({
    modal: {
      '& .MuiDialog-paperWidthSm': {
        padding: '16px',
        width: '90%',
      },
    },

    title: {
      textAlign: 'right',
      padding: '0',
    },
    close: {
      cursor: 'pointer',
    },
    actions: {
      justifyContent: 'space-between',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
  }),
);

export default function PaymentCardExpirationModal({
  open,
  onClose,
  updateProfile,
  updateCard,
  expiryDateAndYear,
}: Props) {
  const { t, richT } = useTranslation();
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      scroll={'paper'}
      className={classes.modal}
      onBackdropClick={onClose}
    >
      <DialogTitle className={classes.title} data-testid="title">
        <CancelIcon
          onClick={onClose}
          className={classes.close}
          data-testid="cancel"
        />
      </DialogTitle>
      <DialogContent
        css={{
          [theme.breakpoints.down('sm')]: {
            padding: '0 24px 40px',
          },
        }}
      >
        <Grid item>
          <Typography variant="h3" style={{ marginBottom: '20px' }}>
            {t('CARD_EXPIRY_TITLE')}
          </Typography>
        </Grid>
        <Grid item>
          <Typography>
            {richT('CARD_EXPIRY_DESC', {
              MONTH_YEAR: expiryDateAndYear,
            })}
          </Typography>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          variant={'contained'}
          color={'primary'}
          onClick={() => {
            updateCard();
          }}
          fullWidth
        >
          {t('UPDATE_PAYMENT_METHOD')}
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            updateProfile();
          }}
          fullWidth
        >
          {t('ADD_SELECT_PAYMENT_METHOD')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
